import { Inject, Injectable, Injector } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from '../base.service';
import { IAppConfig } from '../Config/app-config.model';
import { PublicationDateModel } from 'src/app/shared/model/publication-date.model';
import { DueDateModel } from 'src/app/shared/model/DueDate.model';

@Injectable({
  providedIn: 'root'
})
export class LookupService extends BaseService {

  constructor(public _injector: Injector, @Inject('appconfig') private configParam: IAppConfig) {
    super(_injector);
   }

  GetPublicationDates(newDates: boolean): Observable<PublicationDateModel[]> {
    if (newDates) {
      return this.Get<PublicationDateModel[]>(`${this.configParam.ApiConfig.API_ENDPOINT}Lookup/newPublications`);
    } else {
      return this.Get<PublicationDateModel[]>(`${this.configParam.ApiConfig.API_ENDPOINT}Lookup/publications`);
    }
  }

  GetDueDate(publishId: string, dueDateId: string): Observable<DueDateModel> {
    return this.Get<DueDateModel>(`${this.configParam.ApiConfig.API_ENDPOINT}DueDate?publishId=${publishId}&dueDateId=${dueDateId}`);
  }
}
